module.exports = {
  AccountLoginFailed: {
    name: "LoginFailed",
    message: "Your username or password is incorrect",
  },
  CredentialMaxForConnection: {
    name: "Create Credential Failed",
    message: "You only allow to create maximum 2 credentials",
  },
};
